__webpack_require__.p = "/mw_v2/viewlist/details/";